/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Provider } from "../components/Filters/types";

export const cloudProvidersList = [
  {
    label: Provider.AWS,
    value: Provider.AWS,
  },
  {
    label: Provider.AZURE,
    value: Provider.AZURE,
  },
  {
    label: Provider.GCP,
    value: Provider.GCP,
  },
  {
    label: Provider.ALIBABA,
    value: Provider.ALIBABA,
  },
  {
    label: "IBM CLOUD",
    value: Provider.IBM_CLOUD,
  },
  {
    label: "ON PREMISE",
    value: Provider.ON_PREMISE,
  },
];
